let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("amd3a")).then(() => parcelRequire('6LiLg'));